<h1 class="flashing-text">Connect, Care, and Expand—Invite a Fellow Doctor</h1>

<h2>Share your referral code & get complementary 1 month subscription coupon free*</h2>

<div *ngIf="isLoggedIn">
  <div class="referral-code-container">
    <div>
      <h3>Your Referral Code:</h3>
      <mat-hint>Share this code to get 1 month free subscription coupon</mat-hint>
    </div>
    <div class="code-container">
      <div class="referral-code">{{referralCode}}</div>
    </div>
  </div>
</div>

<h5>*Get 1 month subscription free when referred user registers & purchase their first subscription</h5>